{
  "type": "object",
  "name": "FindVoucher",
  "class": "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-auto gap-4",
  "definitions": [
    {
      "type": "select",
      "name": "datumsart",
      "title": "Datumsart",
      "required": true,
      "control": "dropdown",
      "class": "md:col-span-2 xl:col-span-1",
      "default": "belegdatum",
      "options": [
        { "value": "belegdatum", "title": "Belegdatum" },
        { "value": "periodendatum", "title": "Abrechnungsdatum" },
        { "value": "erfzeit", "title": "Erfassungsdatum" }
      ]
    },
    {
      "type": "date",
      "name": "from",
      "title": "Von Datum",
      "required": true,
      "class": "",
      "default": "h-3m"
    },
    {
      "type": "date",
      "name": "to",
      "title": "Bis Datum",
      "required": true,
      "class": "",
      "default": "h"
    },
    {
      "type": "number",
      "name": "belegnummer",
      "title": "StreckenNr.",
      "class": ""
    },
    {
      "type": "string",
      "name": "bezugsnummer",
      "title": "FremdbelegNr.",
      "class": ""
    },
    {
      "type": "select",
      "name": "kzbelegart",
      "title": "Belegart",
      "options": [
        {
          "value": "R",
          "title": "Eingangsrechnung"
        },
        {
          "value": "G",
          "title": "Gutschrift"
        },
        {
          "value": "E",
          "title": "Buchungsbrief"
        },
        {
          "value": "K",
          "title": "Gekürzte Rechnung"
        },
        {
          "value": "H",
          "title": "Nachbelastung"
        },
        {
          "value": "T",
          "title": "Teilrechnung"
        },
        {
          "value": "U",
          "title": "Schlussrechnung"
        }
      ],
      "control": "dropdown"
    },
    {
      "type": "fieldOk",
      "name": "faelldt",
      "title": "Dekade",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{dekade}} - {{bisdatum:DATE.DEFAULT}}",
      "fieldOk": "faelldt",
      "class": "",
      "parameters": {
        "limit": 50
      },
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "dekade",
              "title": "Dekade"
            },
            {
              "type": "date",
              "class": "",
              "name": "bisdatum",
              "title": "Dekadendatum"
            },
            {
              "type": "date",
              "class": "",
              "name": "faelldtmitglied",
              "title": "Einzugsdatum"
            }
          ]
        }
      }],
      "affects": [{
        "name": "property",
        "property": "from",
        "source": "faelldt.vondatum"
      }, {
        "name": "property",
        "property": "to",
        "source": "faelldt.bisdatum"
      }]
    },
    {
      "type": "fieldOk",
      "name": "kontoKreditor",
      "title": "Lieferant",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.lieferant",
      "parameters": {
        "aktivfirma": 0,
        "aktiv": 0,
        "geloescht": 0,
        "sperre": 0,
        "rechnungslieferanten": 0
      },
      "class": "md:col-span-2 lg:col-span-1",
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "nummer",
              "title": "Nummer"
            },
            {
              "type": "string",
              "class": "",
              "name": "kurzbez",
              "title": "Bezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "name1",
              "title": "Name"
            },
            {
              "type": "string",
              "class": "",
              "name": "name2",
              "title": ""
            },
            {
              "type": "string",
              "class": "",
              "name": "postleitzahl",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "ort",
              "title": "Ort"
            },
            {
              "type": "string",
              "class": "",
              "name": "strasse",
              "title": "Straße"
            },
            {
              "type": "string",
              "class": "",
              "name": "landeskennzeichen",
              "title": "Landeskennzeichen"
            }
          ]
        }
      }]
    },
    {
      "type": "fieldOk",
      "name": "konto",
      "title": "Kunde",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.kunde",
      "class": "md:col-span-2 lg:col-span-1",
      "parameters": {
        "geloescht": 0,
        "gesperrt": 0,
        "kategorie": 2,
        "freigabedatum": "Alle",
        "KUNDENABFRAGE_KENNZEICHEN_AKTIV": "ALLE"
      },
      "visible": {
        "name": "permission",
        "permission": "GESAMTABFRAGE.KUNDENSUCHE"
      }
    },
    {
      "type": "fieldOk",
      "name": "kontoLieferadresse",
      "title": "Baustelle",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{kurzbez}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "parameters": {
        "geloescht": 0,
        "gesperrt": 0,
        "kategorie": 2,
        "freigabedatum": "Alle",
        "KUNDENABFRAGE_KENNZEICHEN_AKTIV": "ALLE",
        "kundennummer": {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "ktostammnummer"
        }
      },
      "class": "md:col-span-2 lg:col-span-1",
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "8",
              "title": "Kostenstelle"
            },
            {
              "type": "string",
              "class": "",
              "name": "1",
              "title": "Kurzbezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "13",
              "title": "Straße"
            },
            {
              "type": "string",
              "class": "",
              "name": "14",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "15",
              "title": "Ort"
            }
          ]
        }
      }]
    },
    {
      "type": "select",
      "name": "verbucht",
      "title": "Verbucht",
      "control": "dropdown",
      "class": "",
      "options": [
        { "value": true, "title": "Ja" },
        { "value": false, "title": "Nein" }
      ]
    },
    {
      "type": "fieldOk",
      "name": "objekt",
      "title": "Objekt (Projektnummer in TR/SR)",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{objekt}} - {{bezeichnung}}",
      "fieldOk": "objekt",
      "parameters": {
        "idktostamm_abrech": {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "accountid"
        }
      }
    },
    {
      "type": "string",
      "name": "fakturenfreigabe",
      "default": "J",
      "visible": false
    },
    {
      "type": "boolean",
      "name": "stornoAnzeigen",
      "default": false,
      "visible": false
    }
  ]
}
